import React, { Suspense, useCallback, useContext, useEffect, useMemo, useRef, useState} from "react"
import  Body  from "./Body/Body"
import Footer from "./Footer/Footer"
import "./HomeScreen.css"
import { AppContext } from "../../context/AppContext"
import { cityWithPreposition, Coordonates, Restaurant,slugify,faqBase, cityWithOtherPreposition , faqProx, HomeRestaurant, FilterValue} from "../../components/types/types"
import logoWhite from '../../image/logo/logoWhite.svg'
import { Helmet } from 'react-helmet-async';
import { useNavigate,useLocation } from 'react-router-dom';
import { RestaurantContext } from "../../context/RestaurantContext"
import ChunkErrorBoundary from "../../components/hook/chunkErrorBoundary"
import { useHomeSeo } from "./hookHomeScreen/useHomeSeo"
import { useHomeRouteMode } from "./hookHomeScreen/useHomeRouteMode"
import { useIndexableRouteSync } from "./hookHomeScreen/useIndexableRouteSync"
import { buildSearchQuery, useSearchQuerySync } from "./hookHomeScreen/useSearchQuerySync";
import SearchPage from "./SearchPage/searchPage"
import HomeTopBar from "./TopBar/homeTopBar"
import { getIndexableFilterValue } from "./SearchPage/hookSearchPage"

type KnownCity = {
    name: string;
    cityNameRaw: string,
    slug: string;
    latitude: string;
    longitude: string;
};

type HomeNavigationState = {
    topBarMode?: string;
    knownCity?: KnownCity;
};

const normalizeCity = (s?: string) =>(s || "").trim().toLowerCase();

export interface HomeSection {
  id: number;
  title: string;
  pageKind: string;
  specialKind?:string,
  slugPath?: string;
  homepageZone?: string;
  homepageWeight?: number;
  filterValue?: string;
  cityName?: string;
  restaurants: HomeRestaurant[];
}

const ConnectionScreen = React.lazy(() => import("../ConnectionScreen/ConnectionScreen"));
const ShowAllCuisine = React.lazy(() => import("../../components/showAllFilters/showAllCuisine"));
const ShowAllType = React.lazy(() => import("../../components/showAllFilters/showAllType"));
const CantProximity = React.lazy(() => import("../../components/cantProximity/cantProximity"));

const fetchCityData = async (cityName: string) => {
    
  let data = null;
    try {
        const response = await fetch(`https://api-adresse.data.gouv.fr/search/?q=${cityName}&limit=10`);
        if (response.ok) return await response.json();
    } catch (err) {
        data = null;
    }
  if (!data || data === null) {
    try {
         const response = await fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/getListCity`, { 
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({cityName}),
        });
        if (response.ok) return await response.json();
    } catch (err) {
        data = null;
    }
  }
  return data;
};
const pickFeature = (features: any[], citySlugFromUrl: string) => {
  if (!Array.isArray(features) || features.length === 0) return null;
  const maineLoire = features.filter(f => (f?.properties?.postcode || '').startsWith('49'));
  const candidates = maineLoire.length ? maineLoire : features;

  const exact = candidates.find(f => slugify(f?.properties?.city || '') === citySlugFromUrl);
  if (exact) return exact;
  return candidates.reduce((best, f) =>
    (f?.properties?.score ?? 0) > (best?.properties?.score ?? 0) ? f : best
  , candidates[0]);
};
const normalizeFilterValue = (value: string) =>
  value
    .toLowerCase()
    .trim()
    .replace(/^[^a-zà-ÿ0-9]+/i, "")
    .trim();
const topCities = [
    { name: "Restaurants à Angers", url: "https://www.quelresto.fr/angers" },
  { name: "Restaurants à Brissac-Loire-Aubance", url: "https://www.quelresto.fr/brissac-loire-aubance" },
  { name: "Restaurants à Mûrs-Erigné", url: "https://www.quelresto.fr/murs-erigne" },
  { name: "Restaurants aux Ponts-de-Cé", url: "https://www.quelresto.fr/les-ponts-de-ce" },
  { name: "Restaurants à Trélazé", url: "https://www.quelresto.fr/trelaze" },
];

const buildFaqLd = (listFaq:string[][],canonicalUrl:string) => {
  if (!listFaq || listFaq.length < 1) return null;
  return {
    "@type": "FAQPage",
    "@id": `${canonicalUrl}#faq`,
    "mainEntity": listFaq.map(( elem, a ) => ({
      "@type": "Question",
      "name": elem[0],
      "acceptedAnswer": { "@type": "Answer", "text": elem[1] }
    }))
  };
};
const priceRangeFromTotal = (p?: number) =>
        typeof p === "number"
            ? p <= 15 ? "€" : p <= 30 ? "€€" : p <= 60 ? "€€€" : "€€€€"
            : undefined;
const buildItemListLd = (restos: Restaurant[],label: string,canonicalUrl: string,limit = 10) => {
    const origin = typeof window !== "undefined" ? window.location.origin : "https://www.quelresto.fr";
    const top = restos.slice(0, limit);
    if (!top.length) return null;
 
    const itemListElement = top.map((r, i) => {
        const citySlug = slugify(r.address?.[1] ?? '');
        const rUrl     = `${origin}/restaurant/${citySlug}/${slugify(r.name)}_${r.id_url}`;
        const item: any = {
            "@type": "Restaurant",
            "@id":   `${rUrl}#restaurant`,
            "name":  r.name,
            "url":   rUrl,
        };
        if (r.devanture) item.image = r.devanture;
        const avgPrice = Array.isArray(r.price_range) && r.price_range.length === 2 ? (r.price_range[0] + r.price_range[1]) / 2 : undefined;
        const pr = priceRangeFromTotal(avgPrice);
        if (pr) item.priceRange = pr;
        if ((r.nbr_review ?? 0) > 0 && (r.note ?? 0) > 0) {
            item.aggregateRating = {
                "@type":       "AggregateRating",
                "ratingValue": Number(r.note),
                "reviewCount": Number(r.nbr_review),
                "bestRating":  5,
                "worstRating": 1,
            };
        }
        if (r.address?.[1]) {
            item.address = {
                "@type":           "PostalAddress",
                "addressLocality": r.address[1],
                ...(r.address?.[0] ? { "streetAddress": r.address[0] } : {}),
                "addressCountry":  "FR",
            };
        }
        const cuisines = Array.isArray(r.cuisines) ? r.cuisines
            .filter((c): c is string => typeof c === "string" && c.trim() !== "")
            .map(c => {
                const clean = c.trim();
                return clean.includes(":") ? clean.split(":").pop()!.trim() : clean;
            })
            .filter(Boolean)
        : [];
        if (cuisines.length) {
            item.servesCuisine = cuisines;
        }

        return { "@type": "ListItem", "position": i + 1, "item": item };
    });
 
    return {
        "@type": "ItemList",
        "@id": `${canonicalUrl}#list`,
        "name": label,
        "itemListOrder":     "https://schema.org/ItemListOrderDescending",
        "numberOfItems":     itemListElement.length,
        "itemListElement":   itemListElement,
    };
};


const HomeScreen = () => {
    const {setDate_selected,setHour_selected, openSearchPage,setValueSearchCity,connectionScreen,fetchIndexablePages,indexablePages,indexablePagesLoaded,coordonates,loadPage,setLoadPage,setFilterChoose,setCoordonates,filterChoose,hour_selected,date_selected,setSearchCity,setCurrentNeighborhood,currentNeighborhood} = useContext(AppContext)
    const {listResto,setListResto,listRestoHome,setFetchResto,fetchRestaurants,fetchResto,listRestoFiltered} = useContext(RestaurantContext)
    const [showAll,setShowAll] = useState(0)
    const location = useLocation();

    const knownCity = (location.state as HomeNavigationState | null)?.knownCity;
    
    const currentYear = new Date().getFullYear();

    const [showWaitingSearch,setShowWaitingSearch] = useState(false)

    const [firstOpenSearch,setFirstOpenSearch] = useState(true)
    useEffect(() => {
        if(openSearchPage && firstOpenSearch) setFirstOpenSearch(false)
    },[openSearchPage])
    const hasSearchQuery = useMemo(() => {
        const params = new URLSearchParams(location.search);
        return (params.has("f") ||params.has("date") ||params.has("hour") || params.has("timePreset") || params.has("priceMin") ||params.has("priceMax") ||params.has("neighborhood"));
    }, [location.search]);
    const activeSearch =  hasSearchQuery || filterChoose.length > 0 || !!hour_selected || !!date_selected;
    const { mode, city: routeCity, filter: routeFilter } = useHomeRouteMode(activeSearch);

    useEffect(() => {
        fetchIndexablePages()
    },[])
    const seoPage = useHomeSeo(indexablePages);
    const isRouteControlledByIndexablePages = mode === "city_filter" || mode === "filter";
    const shouldRedirectUnknownIndexableRoute = indexablePagesLoaded && isRouteControlledByIndexablePages && !seoPage;
    const isPageWithPotentialSeoFromIndexable = mode === "city_filter" || mode === "filter";

    const seoFilterValue = mode === "filter" || mode === "city_filter" ? getIndexableFilterValue(seoPage) : null;
    useSearchQuerySync({filterChoose,setFilterChoose,dateSelected: date_selected,setDateSelected: setDate_selected,hourSelected: hour_selected,setHourSelected: setHour_selected,currentNeighborhood,setCurrentNeighborhood,seoFilterValue,});

    const navigate = useNavigate()
    useEffect(() => {
        if (!shouldRedirectUnknownIndexableRoute) return;

        setFinalCityLoad("");
        setFinalCityLoadBrut("");
        setFetchResto(true);
        navigate("/", { replace: true });
    }, [shouldRedirectUnknownIndexableRoute, navigate, setFetchResto]);

    const canonicalUrl = typeof window !== 'undefined'
    ? `${window.location.origin}${location.pathname}`
    : '';
    const itemListHome = useMemo(() => ({
        "@type": "ItemList",
        "name": "Villes populaires",
        "itemListElement": topCities.map((c, i) => ({
            "@type": "ListItem",
            "position": i + 1,
            "item": { "@type": "WebPage", "name": c.name, "url": c.url }
        }))
    }), []);
    const homeWebPageLd = useMemo(() => ({
        "@type": "WebPage",
        "@id": "https://www.quelresto.fr/#webpage",
        "url": "https://www.quelresto.fr/",
        "name": `QuelResto – Les meilleurs restaurants à proximité – ${currentYear}`,
        "inLanguage": "fr-FR",
        "isPartOf": { "@id": "https://www.quelresto.fr/#website" },
        "about": { "@id": "https://www.quelresto.fr/#organization" },
        "description": "Trouvez facilement les bons restaurants à proximité : menus, photos, avis et infos pratiques. Avec QuelResto, vous pouvez enfin choisir vos restaurants simplement."
    }), [currentYear]);
    const homeLd = useMemo(() => ({
        "@context": "https://schema.org",
        "@graph": [homeWebPageLd,itemListHome,buildFaqLd(faqBase,canonicalUrl)]
    }), [homeWebPageLd, itemListHome, canonicalUrl]);
    const jsonLdProx = useMemo(() => ({
        "@context": "https://schema.org",
        "@graph": [{
            "@type": "WebPage",
            "@id": "https://www.quelresto.fr/restaurants-a-proximite#webpage",
            "name": "Les bons restaurants à proximité",
            "description": "Restaurants à proximité : cartes, photos, horaires et adresses. Trouvez facilement un restaurant autour de vous.",
            "url": canonicalUrl,
            "isPartOf": { "@id": "https://www.quelresto.fr/#website" },
            "breadcrumb": { "@id": "https://www.quelresto.fr/restaurants-a-proximite#breadcrumb" }
        },
        {
            "@type": "BreadcrumbList",
            "@id": "https://www.quelresto.fr/restaurants-a-proximite#breadcrumb",
            "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "Accueil", "item":"https://www.quelresto.fr/" },
                { "@type": "ListItem", "position": 2, "name": "Restaurants à proximité", "item": canonicalUrl }
        ]},
        buildFaqLd(faqProx,canonicalUrl)
    ]}), [canonicalUrl]);
    const [cityEntity,setCityEntity] = useState({})
    const [breadcrumbEntity,setBreadcrumbEntity] = useState({})
    const [finalCityLoad,setFinalCityLoad] = useState<string>(routeCity ||'')
    const [finalCityLoadBrut,setFinalCityLoadBrut] = useState<string>(routeCity ||'')
    const [cantProximity,setCantProximity] = useState(false)

    const searchQuery = useMemo(() =>
        buildSearchQuery({filterChoose,dateSelected: date_selected,hourSelected: hour_selected,currentNeighborhood,seoFilterValue,}),
    [filterChoose,date_selected,hour_selected,currentNeighborhood,seoFilterValue]);
    useIndexableRouteSync({mode,routeCity,seoPage,indexablePagesLoaded,indexablePages,filterChoose,setFilterChoose,setFinalCityLoad,setFinalCityLoadBrut,setValueSearchCity,searchQuery});


    useEffect(() => {
        if (!routeCity || routeCity === 'restaurants-a-proximite') return;
        
        const link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = 'https://api-adresse.data.gouv.fr';
        link.crossOrigin = 'anonymous';
        document.head.appendChild(link);
        
        return () => { document.head.removeChild(link); };
    }, [routeCity]);


    const fetchRestaurantsWithCoords = useCallback(async (coordsLoad?:Coordonates,city?:string,distance?: number) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/getRestoCoords`, { 
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    latitude: coordsLoad?.latitude || coordonates.latitude,
                    longitude: coordsLoad?.longitude || coordonates.longitude,
                    ...(city ? {cityname:city} : {}),
                    ...(distance !== undefined ? { distance } : {}),
                }),
            });
            if (!response.ok) {
                throw new Error(`Erreur getRestoCoords : ${response.status}`);
            }
            const data: Restaurant[] = await response.json();
            setListResto(data);
            setFetchResto(true);
                
        } catch (error) {
            console.error("Error fetching restaurant data:", error);
            setFetchResto(true);
        }
    }, [coordonates.latitude,coordonates.longitude,setFetchResto,setFilterChoose,setListResto]);
    const resolvedCitySlugRef = useRef<string | null>(null);
    const applyResolvedCity = useCallback((
        cityDisplayName: string,
        cityQueryName: string,
        citySlug: string,
        coords: Coordonates
    ) => {
        resolvedCitySlugRef.current =  citySlug;
        setFetchResto(false);
        setCoordonates(coords);
        const cityPrep = cityWithPreposition(cityDisplayName);

        setFinalCityLoad(cityPrep);
        setFinalCityLoadBrut(cityDisplayName);
        setValueSearchCity(cityDisplayName);
        setSearchCity(cityDisplayName);

        setCityEntity({
            "@type": "City",
            "mainEntityOfPage": {
                "@id": `${canonicalUrl}#webpage`
            },
            "@id": `${canonicalUrl}#city`,
            "name": cityDisplayName,
            "address": {
                "@type": "PostalAddress",
                "addressLocality": cityDisplayName,
                "addressRegion": "Pays de la Loire",
                "addressCountry": "FR"
            },
            "geo": {
                "@type": "GeoCoordinates",
                "latitude": Number(
                    coords.latitude
                ),
                "longitude": Number(
                    coords.longitude
                )
            }
        });

        setBreadcrumbEntity({
            "@type": "BreadcrumbList",
            "@id": `${canonicalUrl}#breadcrumb`,
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Accueil",
                    "item": "https://www.quelresto.fr/"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "name": cityDisplayName,
                    "item": canonicalUrl
                }
            ]
        });

        fetchRestaurantsWithCoords(
            coords,
            cityQueryName
        );
    }, [canonicalUrl,fetchRestaurantsWithCoords,setCoordonates,setFetchResto,setSearchCity,setValueSearchCity]);
    const validateCity = async (cityName: string) => {
        try {
            const data = await fetchCityData(cityName);
            if (data.features && data.features.length > 0) {
                const feature = pickFeature(data.features, cityName);
                if (!feature) {
                    setFinalCityLoad('');
                    setFinalCityLoadBrut('');
                    fetchRestaurants();
                    navigate('/', { replace: true });
                    return;
                }

                const properties = feature.properties;
                const coords: Coordonates = {
                latitude: feature.geometry.coordinates[1],
                longitude: feature.geometry.coordinates[0],
                };

                const tempFinalCity = properties.oldcity && cityName === slugify(properties.oldcity)
                ? properties.oldcity
                : properties.city;

                const slugCity = slugify(properties.city);

                const case1 = properties.city && (properties.score > 0.9 && cityName === slugCity);
                const case2 = properties.city && (properties.score > 0.6 && properties.oldcity && cityName === slugify(properties.oldcity))

                if (case1 || case2) {
                    applyResolvedCity(tempFinalCity,tempFinalCity,cityName,coords);

                } else if (properties.city && (properties.score > 0.6 && properties.oldcity) && cityName === slugCity) {
                    navigate('/' + slugify(properties.oldcity), { replace: true });
                } else if (properties.city && properties.score > 0.5) {
                    navigate('/' + slugCity, { replace: true });
                } else {
                    setFinalCityLoad(''); 
                    setFinalCityLoadBrut('')
                    fetchRestaurants()
                    navigate('/', { replace: true });
                }
            } else {
                setFinalCityLoad(''); 
                setFinalCityLoadBrut('')
                fetchRestaurants()
                navigate('/', { replace: true });
            }
        } catch (error) {
            setFinalCityLoad(''); 
            setFinalCityLoadBrut('')
            fetchRestaurants()
            navigate('/', { replace: true });
        }
    };  
    const canUseKnownCity = !!knownCity && !!routeCity && knownCity.slug === routeCity && Number.isFinite(Number(knownCity.latitude)) && Number.isFinite(Number(knownCity.longitude));
    useEffect(() => {
        if (mode === "home") {
            setFinalCityLoad("");
            setFinalCityLoadBrut("");
            setFetchResto(true); 
            resolvedCitySlugRef.current = null;
            return;
        }
        if (mode === "home_filter" || mode === "filter" || mode === "all_restaurants") {
            resolvedCitySlugRef.current = null;
            if (listRestoHome.length > 0) {
                setListResto(listRestoHome);
                setFetchResto(true)
            }
            else fetchRestaurants();

            setFinalCityLoad("");
            setFinalCityLoadBrut("");
            return;
        }

        if (routeCity === "restaurants-a-proximite") {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                (position) => {
                    const userLocation: Coordonates = {
                    latitude: position.coords.latitude.toString(),
                    longitude: position.coords.longitude.toString(),
                    };
                    resolvedCitySlugRef.current = "restaurants-a-proximite";
                    setSearchCity("À proximité");
                    setValueSearchCity("À proximité");
                    setFinalCityLoad("à proximité");
                    setFinalCityLoadBrut("à proximité");
                    setCoordonates(userLocation);
                    setFetchResto(false);
                    fetchRestaurantsWithCoords( userLocation,"À proximité",5);
                },
                () => {
                    setCantProximity(true);
                    fetchRestaurants();
                }
                );
            }
            return;
        }

        if ((mode === "city" || mode === "city_filter") && routeCity) {
            if (resolvedCitySlugRef.current === routeCity) {
                setFetchResto(true);
                return;
            }
            if (canUseKnownCity && knownCity) {
                applyResolvedCity(knownCity.name, knownCity.cityNameRaw,routeCity,{latitude: knownCity.latitude, longitude: knownCity.longitude});
                return;
            }
            validateCity(routeCity);
            return;
        }
    }, [mode, routeCity,knownCity,canUseKnownCity,applyResolvedCity]);

    const lastTrackedPathRef = useRef<string | null>(null);
    useEffect(() => {
        if (!window.gtag) return;
        const cookieConsent = document.cookie.split("; ").find(row => row.startsWith("QUELRESTO_COOKIE="));
        if (!cookieConsent) return;
        try {
            const cookieValue = decodeURIComponent(cookieConsent.split("=")[1]);
            const parsed = JSON.parse(cookieValue);
            const hasAnalyticsConsent = parsed["perform-analytics"];
            const existingScript = document.querySelector('script[src*="googletagmanager.com/gtag/js"]');

            if (!hasAnalyticsConsent || !existingScript) return;
            const isCityPage = !!routeCity && routeCity !== "restaurants-a-proximite";
            if (isCityPage && finalCityLoadBrut) {
                let currentPath = window.location.pathname
                if (lastTrackedPathRef.current === currentPath) return;
                lastTrackedPathRef.current = currentPath;
                window.gtag('config', `G-${process.env.REACT_APP_TAG_ANALYSE}`, {
                    page_path: window.location.pathname
                });
            }
        } catch (error) {
            console.error("Erreur tracking HomeScreen :", error);
        }
    }, [routeCity, finalCityLoadBrut, location.pathname]);

    useEffect(() => {
        setTimeout(() => {
            setLoadPage(true)
        },2300)
    },[])

    const funcClose = () => {
        setShowAll(0)
    }

    const shouldBuildCityLd = !!finalCityLoad && finalCityLoad !== "à proximité" && !seoPage;
    const cityItemListLd = useMemo(() => {
        if (!shouldBuildCityLd || !listResto.length) return null;
        return buildItemListLd(
            [...listResto].slice(0, 10),
            `Restaurants ${finalCityLoad}`,
            canonicalUrl
        );
    }, [listResto, finalCityLoad, canonicalUrl, shouldBuildCityLd]);

    const collectionPageLd = useMemo(() => ({
        "@type": "CollectionPage",
        "@id": `${canonicalUrl}#webpage`,
        "url": canonicalUrl,
        "name": `Trouvez un bon restaurant ${finalCityLoad} – QuelResto`,
        "inLanguage": "fr-FR",
        "isPartOf": { "@id": "https://www.quelresto.fr/#website" },
        "about": { "@id": `${canonicalUrl}#city` },
        "breadcrumb": { "@id": `${canonicalUrl}#breadcrumb` },
        "contentLocation": { "@id": `${canonicalUrl}#city` },
        "description": `Trouvez un bon restaurant ${finalCityLoad} : menus, photos, avis, horaires et prix moyens. Contact direct des établissements — QuelResto.`,
        ...(cityItemListLd ? { "mainEntity": { "@id": `${canonicalUrl}#list` } } : {})
    }), [canonicalUrl, finalCityLoad, cityItemListLd]);

    const jsonLdVille = useMemo(() => {
        if (!shouldBuildCityLd) return null;
        return {
        "@context": "https://schema.org",
        "@graph": [
            cityEntity,
            collectionPageLd,
            breadcrumbEntity,
            ...(finalCityLoad ? [buildFaqLd([[`Comment trouver facilement un restaurant ${finalCityLoad} et ses alentours`,`Sur QuelResto, vous pouvez comparer facilement tous les restaurants ${finalCityLoad} grâce aux cartes, photos, horaires et avis disponibles sur chaque restaurants. Pour explorer aussi les restaurants à proximité ${cityWithOtherPreposition(finalCityLoad)}, utilisez les pages dédiées aux villes voisines ou naviguez dans la liste complète des établissements référencés.`],
                [`Où voir la carte, les photos et les avis des restaurants ${finalCityLoad}`,`Sur QuelResto, chaque restaurant ${finalCityLoad} dispose d’une page complète avec sa carte, ses photos, ses horaires et les avis clients. Vous pouvez ainsi comparer facilement les restaurants ${finalCityLoad} et choisir l’adresse qui correspond le mieux à vos envies.`],
                [`Comment trouver un restaurant pas cher, romantique, avec terrasse, concrètement un restaurant adapté à mes envies ou à mes besoins ${finalCityLoad}`,`QuelResto vous permet de filtrer les restaurants ${finalCityLoad} selon vos besoins et envies. Vous pouvez par exemple trouver un restaurant pas cher, un restaurant romantique, un restaurant avec terrasse, ou encore choisir selon le budget, l’ambiance, un régime alimentaire (végétarien, végan, halal, sans gluten) mais aussi des critères comme l’accessibilité PMR ou le parking. L’ensemble des filtres disponibles vous permet ainsi de comparer facilement les restaurants ${finalCityLoad} et de trouver l’adresse la plus adaptée à vos envies et à vos besoins.`],
                [`Peut-on réserver un restaurant en ligne ${finalCityLoad}`,`Sur chaque page restaurant ${finalCityLoad}, vous retrouvez une section réservation avec le numéro de téléphone du restaurant. Si l’établissement propose une réservation en ligne via son propre outil, un lien pour y accéder est affiché. À l’avenir, QuelResto intégrera sa propre réservation en ligne pour réserver rapidement et avoir des avis vérifiés. Vous pourrez ainsi réserver un restaurant ${finalCityLoad} en quelques clics, simplement et en toute confiance.`]],canonicalUrl)] : []),
            ...(cityItemListLd ? [cityItemListLd] : [])
        ]}
    }, [cityEntity, collectionPageLd, breadcrumbEntity, cityItemListLd,finalCityLoad]);


    const seoPageFilteredRestos = useMemo(() => {
        if (!seoPage || !listResto.length) return [];
        const activeFilters = seoPage.filter_name ? [seoPage.filter_name] : filterChoose.filter((f): f is string => typeof f === "string");
        if (!activeFilters.length) return listResto.slice(0, 10);
        return listResto
            .filter(r =>
                activeFilters.every(f =>
                    r.filters?.includes(f) ||
                    r.cuisines?.includes(f) ||
                    r.type?.some(t => normalizeFilterValue(t) === normalizeFilterValue(f))
                )
            )
            .slice(0, 10);
    }, [seoPage, listResto, filterChoose]);
    const seoPageItemListLd = useMemo(() => {
        if (!seoPage || !seoPageFilteredRestos.length) return null;
        return buildItemListLd(
            seoPageFilteredRestos,
            seoPage.seo_title || seoPage.label,
            canonicalUrl
        );
    }, [seoPage, seoPageFilteredRestos, canonicalUrl]);
    const seoPageBreadcrumbLd = useMemo(() => {
        if (!seoPage) return null;
        const items: any[] = [
            { "@type": "ListItem", "position": 1, "name": "Accueil", "item": "https://www.quelresto.fr/" },
        ];
        if (seoPage.page_kind === "city_filter" && seoPage.city_slug && seoPage.city_name) {
            items.push({
                "@type":    "ListItem",
                "position": 2,
                "name":     seoPage.city_name,
                "item":     `https://www.quelresto.fr/${seoPage.city_slug}`,
            });
            items.push({
                "@type":    "ListItem",
                "position": 3,
                "name":     seoPage.seo_title || seoPage.label,
                "item":     canonicalUrl,
            });
        } else {
            items.push({
                "@type":    "ListItem",
                "position": 2,
                "name":     seoPage.seo_title || seoPage.label,
                "item":     canonicalUrl,
            });
        }
        return {
            "@type":           "BreadcrumbList",
            "@id":             `${canonicalUrl}#breadcrumb`,
            "itemListElement": items,
        };
    }, [seoPage, canonicalUrl]);
 
    const seoPageLd = useMemo(() => {
        if (!seoPage) return null;
        return {
            "@context": "https://schema.org",
            "@graph": [
                {
                    "@type":       "CollectionPage",
                    "@id":         `${canonicalUrl}#webpage`,
                    "url":         canonicalUrl,
                    "name":        seoPage.seo_title || seoPage.label,
                    "inLanguage":  "fr-FR",
                    "isPartOf":    { "@id": "https://www.quelresto.fr/#website" },
                    "breadcrumb":  { "@id": `${canonicalUrl}#breadcrumb` },
                    ...(seoPage.seo_description ? { "description": seoPage.seo_description } : {}),
                    ...(seoPageItemListLd ? { "mainEntity": { "@id": `${canonicalUrl}#list` } } : {}),
                },
                ...(seoPageBreadcrumbLd ? [seoPageBreadcrumbLd] : []),
                ...(seoPageItemListLd   ? [seoPageItemListLd]   : []),
            ],
        };
    }, [seoPage, canonicalUrl, seoPageBreadcrumbLd, seoPageItemListLd]);


    useEffect(() => {
        if (!loadPage) return;
        if ("scrollRestoration" in window.history) {
            window.history.scrollRestoration = "manual";
        }
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
            window.scrollTo({ top: 0, left: 0, behavior: "auto" });
            });
        });
    }, [location.key]);

    const [baseSortSection,setBaseSortSection] = useState('')
    const topBarType = mode === "home" ? "primary" : "secondary";
    const [homeSections, setHomeSections] = useState<HomeSection[]>([]);
    const [homeSectionsLoading, setHomeSectionsLoading] = useState(true);
    const [homeSectionsRefreshLoading, setHomeSectionsRefreshLoading] = useState(false);
    const fetchHomeSections = useCallback(async (
        url: string,
        elem:string,
        options?: RequestInit,
        isInitialLoad = false
    ) => {
        if (isInitialLoad) setHomeSectionsLoading(true);
        else setHomeSectionsRefreshLoading(true);
        setBaseSortSection(elem)
        try {
            const response = await fetch(
            `${process.env.REACT_APP_DIRECTION_REQUEST}${url}`,
            options ?? {
                method: "GET",
                headers: {
                "Content-Type": "application/json",
                },
            }
            );

            const data = await response.json();
            if (data.success && Array.isArray(data.sections)) {
            setHomeSections(data.sections);
            }
        } catch (error) {
            console.error("Erreur chargement sections home :", error);
        } finally {
            if (isInitialLoad) setHomeSectionsLoading(false);
            else setHomeSectionsRefreshLoading(false);
        }
    }, []);

    useEffect(() => {
        if (mode !== "home") return;
        if (homeSections.length > 0) return;

        fetchHomeSections("/api/getHomeSections","", undefined, true);
    }, [mode, homeSections.length, fetchHomeSections]);

    const [currentFilter, setCurrentFilter] = useState<FilterValue[]>(filterChoose);
    useEffect(() => {
        setCurrentFilter([...filterChoose]);
    }, [filterChoose]);
    const targetCityNormalized = useMemo(() => normalizeCity(finalCityLoadBrut),[finalCityLoadBrut]);
    const getNeighborhoodResultCount = useCallback((neighborhoods: string[]) => {
        const base = listRestoFiltered ?? [];
        const filteredByNeighborhood = neighborhoods.length > 0 ? base.filter((restaurant) =>neighborhoods.includes(restaurant.neighborhood)) : base;
        if (!targetCityNormalized ||targetCityNormalized === normalizeCity("à proximité")) return filteredByNeighborhood.length;
        return filteredByNeighborhood.filter((restaurant) => {
            const restaurantCity = normalizeCity(restaurant.address?.[1]);
            const visibleCity = normalizeCity(restaurant.visiblecity);
            return (restaurantCity === targetCityNormalized ||visibleCity === targetCityNormalized);
        }).length;
    },[listRestoFiltered,targetCityNormalized]);
    const toolbarRestaurants = useMemo(() => {
        let base = listResto ?? [];
        if (currentNeighborhood.length > 0)  base = base.filter((restaurant) =>currentNeighborhood.includes(restaurant.neighborhood));

        if (targetCityNormalized &&targetCityNormalized !== normalizeCity("à proximité")) {
            base = base.filter((restaurant) => {
                const restaurantCity = normalizeCity(restaurant.address?.[1]);
                const visibleCity = normalizeCity(restaurant.visiblecity);
                return restaurantCity === targetCityNormalized || visibleCity === targetCityNormalized;
            });
        }
        return base;
    }, [listResto,currentNeighborhood,targetCityNormalized]);
    const handleToolbarFiltersChange = (nextFilters: FilterValue[]) => {
        if (routeCity) return;
        const hasDateOrHour = !!date_selected || hour_selected !== "";
        const nextSearch = buildSearchQuery({
            filterChoose: nextFilters,
            dateSelected: date_selected,
            hourSelected: hour_selected,
            currentNeighborhood,
        });
        if (nextFilters.length === 0 && !hasDateOrHour) {
            navigate(
                {pathname: "/restaurants",search: nextSearch,},
                {state: {...(location.state ?? {}),topBarMode: "search",}}
            );
            return;
        }
        navigate(
        {pathname: "/",search: nextSearch},
        {state: {...(location.state ?? {}),topBarMode: "search"},}
    );
    };

    return (
        <>
        <Helmet>
            <link rel="canonical" href={canonicalUrl} />
             {seoPage ? (
                <>
                <title>{seoPage.seo_title || seoPage.label}</title>

                {seoPage.seo_description && (
                    <meta name="description" content={seoPage.seo_description} />
                )}

                <meta property="og:title" content={seoPage.seo_title || seoPage.label} />

                {seoPage.seo_description && (
                    <meta property="og:description" content={seoPage.seo_description} />
                )}

                <meta property="og:url" content={canonicalUrl} />
                {seoPageLd && (
                <script type="application/ld+json">
                    {JSON.stringify(seoPageLd)}
                </script>
                )}
                </>
            ) : isPageWithPotentialSeoFromIndexable && !indexablePagesLoaded ? (<></>
            ) : finalCityLoad  ? (
                finalCityLoad === "à proximité" ? 
                <>
                    <title>Les bons restaurants à proximité</title>
                    <meta
                        name="description" 
                        content={`Restaurants à proximité : cartes, photos, horaires et adresses. Trouvez facilement un restaurant autour de vous.`}
                        />
                    <meta property="og:title" content={`Les bons restaurants à proximité`} />
                    <meta property="og:description" content={`Restaurants à proximité : cartes, photos, horaires et adresses. Trouvez facilement un restaurant autour de vous.`} />
                    <meta property="og:url" content={canonicalUrl} />
                    <script type="application/ld+json">{JSON.stringify(jsonLdProx)}</script>
                </>
                :
                <>
                <title>{`Trouvez un bon restaurant ${finalCityLoad}, Maine-et-Loire – ${currentYear}`}</title>
                <meta
                    name="description" 
                    content={`Restaurants ${finalCityLoad} (Maine-et-Loire) : cartes, photos, horaires et adresses. Trouvez facilement votre restaurant à proximité.`}
                    />
                <meta property="og:title" content={`Trouvez un bon restaurant ${finalCityLoad}, Maine-et-Loire – ${currentYear}`} />
                <meta property="og:description" content={`Restaurants ${finalCityLoad} (Maine-et-Loire) : cartes, photos, horaires et adresses. Trouvez facilement votre restaurant à proximité.`} />
                <meta property="og:url" content={canonicalUrl} />
                {jsonLdVille  && <script type="application/ld+json">{JSON.stringify(jsonLdVille)}</script>}
                </>) 
                : <>
                    <title>{`QuelResto – Les meilleurs restaurants à proximité – ${currentYear}`}</title>
                      <script type="application/ld+json">
                        {JSON.stringify(homeLd)}
                    </script>
                </>
            }
        </Helmet> 
        

        <div className={`homeScreen `}>

            {!loadPage && <div className='loadPage'>
                <div className="containerMove">
                    <img  src={logoWhite} loading="eager" decoding="async" alt="QuelResto"   width={433} height={129}/>
                    <span className="loadPageSubtitle XsmallText">Entreprise <strong>Angevine</strong></span>
                </div>
                <div className="mask"></div>
            </div> }
                <HomeTopBar toolbarRestaurants={toolbarRestaurants} getNeighborhoodResultCount={getNeighborhoodResultCount} type={topBarType} baseSortSection={baseSortSection} fetchSections={fetchHomeSections} routeCity={routeCity ?? ''} routeFilter={routeFilter ?? ''} currentNeighborhood={currentNeighborhood} setCurrentNeighborhood={setCurrentNeighborhood}   setShowAll={setShowAll} globalFilter={currentFilter} setGlobalFilter={setCurrentFilter} setShowWaitingSearch={setShowWaitingSearch}/>
                {!firstOpenSearch && <SearchPage routeCity={routeCity ?? ''} setCurrentNeighborhood={setCurrentNeighborhood} />  }
                
                <Body setShowWaitingSearch={setShowWaitingSearch} getNeighborhoodResultCount={getNeighborhoodResultCount} showWaitingSearch={showWaitingSearch} routeCity={routeCity ?? ''} mode={mode} showAll={showAll} cityLoad={finalCityLoad} cityLoadBrut={finalCityLoadBrut}  setShowAll={setShowAll} fetchResto={fetchResto} seoPage={seoPage} baseSortSection={baseSortSection} fetchSections={fetchHomeSections}
                homeSections={homeSections} homeSectionsLoading={homeSectionsLoading} homeSectionsRefreshLoading={homeSectionsRefreshLoading} currentFilter={currentFilter} setCurrentFilter={setCurrentFilter}/>

                <ChunkErrorBoundary>
                <Suspense fallback={null}>
                    {
                        showAll === 1 ? 
                            <ShowAllCuisine close={funcClose} routeCity={routeCity ?? ""} currentFilter={currentFilter} setCurrentFilter={setCurrentFilter}/>
                            :
                            (showAll === 2 || showAll === 3) && <ShowAllType onFiltersChange={handleToolbarFiltersChange} close={funcClose} routeCity={routeCity ?? ''} showAll={showAll} currentFilter={currentFilter} setCurrentFilter={setCurrentFilter}/>
                    }
                    {
                        connectionScreen ? <ConnectionScreen /> : undefined
                    }
                    {cantProximity ? <CantProximity setCantProximity={setCantProximity}/> : undefined}
                </Suspense></ChunkErrorBoundary>
                <Footer cityLoad={(finalCityLoad && finalCityLoad !== '') ? finalCityLoad : ''} listRestoLoad={(finalCityLoad && finalCityLoad !== '') ? listResto : []} isHomePage={true}/>
                
           
             
        </div>
        </>
    )
}

export default HomeScreen